<template>
    <div style="ls-view-email-modal--container">
        <div>
            <iframe ref="iframe" class="ls-view-email-modal--body"></iframe>
        </div>
        <LsClickable track-id="view_email_modal-close" class="modal-close-x" @click="close">
            <LsIcon type="close" size="lg" />
        </LsClickable>
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import _ from 'lodash';
import { LsClickable, LsIcon } from '@/components/common';

export default {
    name: 'ViewEmailModal',
    components: {
        LsClickable,
        LsIcon,
    },
    props: {
        body: VueTypes.string.isRequired,
    },
    mounted() {
        // strip out all links
        const linksDisabled = '"Links are disabled in admin preview mode"';
        const emailBody = _.replace(
            this.body,
            /href="(.*?)"/g,
            `a href='#' onClick='alert(${linksDisabled}); return false;'`
        );
        const iframe = this.$refs.iframe;
        const iframedoc = _.get(iframe, 'contentDocument');
        _.set(iframedoc, 'body.innerHTML', emailBody);
    },
    methods: {
        close() {
            this.$parent.close();
        },
    },
};
</script>

<style lang="scss">
.ls-view-email-modal--body {
    width: 100%;
    height: 85vh;
    margin-top: 70px;
    padding-top: 40px;
    background-color: $white;

    table * {
        pointer-events: none !important;
        cursor: default;
    }
}

.modal-close-x {
    position: absolute;
    top: 85px;
    right: 20px;
    z-index: $z-index-email-modal;

    @media (max-width: $tablet-max-width) {
        right: 10px;
    }
}
</style>
